import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { map } from "rxjs/operators";
import { GlobalsService } from "../../globals.service";
import { RetentionPolicyService } from "../../retentionpolicies/shared/retentionpolicy.service";
import { QuestionNumberType } from "./questionnumbertype.model";
import { Target } from "./target.model";

@Injectable({ providedIn: "root" })
export class TargetService {
  public dataSource: MatTableDataSource<Target>;
  public questionNumberTypeList: QuestionNumberType[];
  public selectedTarget: Target;
  public targetLibrary: Target[];
  public targetList: Target[];

  public constructor(
    private http: HttpClient,
    private httpClient: HttpClient,
    private globalsService: GlobalsService,
  ) {}

  public deleteTarget(id: number): Promise<Target> {
    return this.http.delete<Target>(`target/${id}`).toPromise();
  }

  public cloneTarget(
    id: number,
    inclDPTDetails: boolean = false,
  ): Promise<number> {
    var path =
      `target/${id}/clone/${this.globalsService.getOwnerID()}/${this.globalsService.getSystem()}?` +
      "includeRelated=true&includeDatasets=false&includeValues=false";

    if (inclDPTDetails) {
      path += "&includeDPTDetails=true";
    }

    return this.http.get<number>(path).toPromise();
  }

  public evalTargetExpressionChains(
    id: number,
    datasetID: number = null,
    iteration: number = null,
  ): Promise<number> {
    return this.http
      .get<number>(
        `target/${id}/eval?datasetID=${datasetID}&iteration=${iteration}`,
      )
      .toPromise();
  }

  public getDefaultQuestionNumberTypeID(): number {
    return this.questionNumberTypeList.filter(
      (p) => p.name.toLowerCase() === "none",
    )[0].id;
  }

  public getNewTarget(): Target {
    const target = new Target();
    target.ownerID = 0;
    target.questionNumberTypeID = this.getDefaultQuestionNumberTypeID();
    return target;
  }

  public getQuestionNumberTypeList(): Promise<QuestionNumberType[]> {
    return this.http
      .get<QuestionNumberType[]>("questionnumbertype/list")
      .toPromise();
  }

  public getTarget(
    targetID: number,
    datasetID: number,
    iteration: number,
    respondentExternalID: number,
    nextIteration: number = -1,
  ): Promise<Target> {
    var path = `target/${targetID}/${respondentExternalID}/?datasetID=${datasetID}&iteration=${iteration}&nextIteration=${nextIteration}`;

    return this.http.get<Target>(path).toPromise();
  }

  public getTargetList(
    ownerID: number = null,
    loadCompletionData: boolean = true,
  ): Promise<Target[]> {
    var oid = ownerID == null ? this.globalsService.getOwnerID() : ownerID;

    this.globalsService.log(
      `TargetService.GetTargetList [ownerID=${oid},loadCompletionData=${loadCompletionData}]`,
    );

    return this.http
      .get<Target[]>(`target/list/${oid}/${loadCompletionData}`)
      .pipe(
        map((data: any) => {
          return data as Target[];
        }),
      )
      .toPromise();
  }

  public getTargetsForExternalID(
    externalID: number = null,
    respondentExternalID: number = null,
    global: boolean = false,
    fromExternalSystem: boolean,
    dashboardID: number = null,
    impersonationMode: number = 0,
    mode: number = this.globalsService.MODE_SURVEY,
    simple: boolean = false,
    library: boolean = false,
  ): Promise<Target[]> {
    this.globalsService.log(
      `TargetService.GetTargetsForExternalID [global=${global};simple=${simple};library=${library}]`,
    );

    const gl = global === true || fromExternalSystem === true ? global : null;
    var path = `target/list/${this.globalsService.getOwnerID()}/${externalID}/${respondentExternalID}/${gl}/${dashboardID}/${impersonationMode}/${mode}`;
    var argDelimiter = "?";
    if (simple) {
      path += `${argDelimiter}simple=true`;
      argDelimiter = "&";
    }
    if (library) {
      path += `${argDelimiter}library=true`;
    }
    if (fromExternalSystem) {
      path += `${argDelimiter}fromExternalSystem=true`;
    }
    return this.httpClient.get<Target[]>(path).toPromise();
  }

  public indexTargetList(targetList: Target[]): Promise<Target[]> {
    const body = JSON.stringify(targetList);
    return this.httpClient
      .post<Target[]>("target/list/index", body)
      .toPromise();
  }

  public postTarget(target: Target): Promise<Target> {
    target.ownerID = this.globalsService.getOwnerID();
    target.ownerDesignerID = this.globalsService.getOwnerDesignerID();
    target.id = 0;
    target.designerID = undefined;
    const body = JSON.stringify(target);
    return this.http.post<Target>("target", body).toPromise();
  }

  public putTarget(target: Target): Promise<Target> {
    target.ownerID = this.globalsService.getOwnerID();
    target.ownerDesignerID = this.globalsService.getOwnerDesignerID();
    const body = JSON.stringify(target);
    return this.http.put<Target>(`target`, body).toPromise();
  }

  public refresh() {
    this.globalsService.log("TargetService.refresh()...");
    if (this.dataSource) {
      this.getTargetList().then((x) => {
        this.dataSource.data = x;
        /*
        if (this.selectedTarget != null) {
          this.selectedTarget = x.filter(t => t.id == this.selectedTarget.id)[0];
        }
        */
      });
    }
  }

  public setTargetLocked(targetID: number, locked: boolean): Promise<boolean> {
    return this.http
      .get<boolean>(`target/${targetID}/lock/${locked}`)
      .toPromise();
  }
}
